import { faBuilding, faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const LLENavListInternal: MenuItem[] = [
    {
        id: 1,
        name: 'summaryReview',
        complete: false,
        componentName: 'Summary',
        icon: faFilePdf
    },
    {
        id: 2,
        name: 'contactInfo',
        componentName: 'ContactInfo',
        complete: false,
    },
    {
        id: 3,
        name: 'incomeExpense',
        componentName: 'IncomeExpense',
        complete: false,
        icon: faMoneyBillTrendUp,
        subItems: [
            {
                id: 31,
                name: 'numberOfSites',
                complete: false,
                componentName: 'NumberOfSites'
            },
            {
                id: 32,
                name: 'incomeRevenue',
                complete: false,
                componentName: 'RevenueContainer',
            },
            {
                id: 33,
                name: 'expenses',
                hasTabs: true,
                complete: false,
                componentName: 'ExpenseContainer',
                subItems: [
                    {
                        id: 331,
                        name: 'general',
                        complete: false,
                    },
                    {
                        id: 332,
                        name: 'admin',
                        complete: false,
                    },
                    {
                        id: 333,
                        name: 'utilities',
                        complete: false,
                    },
                    {
                        id: 334,
                        name: 'propMaintenance',
                        complete: false,
                    },
                    {
                        id: 335,
                        name: 'other',
                        complete: false,
                    },
                    {
                        id: 336,
                        name: 'nonOperatingIncomeExpenses',
                        complete: false,
                    }
                ]
            },
            {
                id: 34,
                name: 'rentalLoss',
                complete: false,
                componentName: 'IncomeAttributeTable'
            },
            {
                id: 35,
                name: 'capitalExpSummary',
                complete: false,
                componentName: 'CapitalCostsSummary'
            },
            {
                id: 36,
                name: 'analysis',
                componentName: 'Analysis',
                complete: false
            }
        ],
    },
    {
        id: 4,
        name: 'residential',
        complete: false,
        icon: faBuilding,
        subItems: [
            {
                id: 41,
                name: 'suiteBreakdownTable',
                complete: false,
                componentName: 'SuiteBreakdown'
            }
        ]
    },
    {
        id: 5,
        name: 'commercial',
        complete: false,
        icon: faCartShopping,
        subItems: [
            {
                id: 51,
                name: 'leaseInformationTable',
                componentName: 'LeaseInfo',
                complete: false
            },
            {
                id: 52,
                name: 'vacantAskingRate',
                complete: false,
                componentName: 'VacantAskingRate',
            },
            {
                id: 53,
                name: 'parkingSummary',
                complete: false,
                componentName: 'ParkingPropertySummary',
            }
        ]
    },
    {
        id: 6,
        name: 'comments',
        complete: false,
        componentName: 'Comment',
    },
    {
        id: 7,
        name: 'submit',
        complete: false,
        icon: faFileInvoiceDollar,
        componentName: 'Submit'
    }
]

export default LLENavListInternal